import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const getUserStatistics = createAsyncThunk(
  "Statistics/getUserStatistics",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/statistic/issues/users`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getEmployeesStatistics = createAsyncThunk(
  "Statistics/getEmployeesStatistics",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/statistic/issues/employees`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getVerdictsStatistics = createAsyncThunk(
  "Statistics/getVerdictsStatistics",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/statistic/users/verdicts`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getIssuesReport = createAsyncThunk(
  "Statistics/getIssuesReport",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/report/issues`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          params: data,
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getVerdictsReport = createAsyncThunk(
  "Statistics/getVerdictsReport",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/report/issues`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          params: data,
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getImplementationsReport = createAsyncThunk(
  "Statistics/getImplementationsReport",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/report/implementations`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getUsersReport = createAsyncThunk(
  "Statistics/getUsersReport",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/report/users`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          params: data,
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getEmployeesReport = createAsyncThunk(
  "Statistics/getEmployeesReport",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/report/employees`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getTasksReport = createAsyncThunk(
  "Statistics/getTasksReport",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/report/tasks`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          params: data || {
            statuses: "Progress",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getSessionsCourtsReport = createAsyncThunk(
  "Statistics/getSessionsCourtsReport",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/report/sessions/courts`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getSessionsUsersReport = createAsyncThunk(
  "Statistics/getSessionsUsersReport",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/report/sessions/users`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getSessionsConsultantsReport = createAsyncThunk(
  "Statistics/getSessionsConsultantsReport",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/report/sessions/consultants`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getDocumentsReport = createAsyncThunk(
  "Statistics/getDocumentsReport",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/report/document_issues`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getCourtsReport = createAsyncThunk(
  "Statistics/getCourtsReport",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/report/courts`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          params: data,
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getformula = createAsyncThunk(
  "Statistics/getformula",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/formula`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          params: data,
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const Addformula = createAsyncThunk(
  "Statistics/Addformula",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/company/formula`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateformula = createAsyncThunk(
  "Statistics/updateformula",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/formula/${data.id}/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const Deleteformula = createAsyncThunk(
  "Statistics/Deleteformula",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/formula/${id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const getEmployeeTrashes = createAsyncThunk(
  "Statistics/getEmployeeTrashes",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/trashes`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          params: {
            type: "employee",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getUsersTrashes = createAsyncThunk(
  "Statistics/getUsersTrashes",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/trashes`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          params: {
            type: "user",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getIssueTrashes = createAsyncThunk(
  "Statistics/getIssueTrashes",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/trashes`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          params: {
            type: "issue",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const ResotreTrashes = createAsyncThunk(
  "Statistics/ResotreTrashes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/trashes/${data.id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            params: data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getSummaryOfTheSessions = createAsyncThunk(
  "Statistics/getSummaryOfTheSessions",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/index/summary_of_the_sessions`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getFollowSchedule = createAsyncThunk(
  "Statistics/getFollowSchedule",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/index/follow_schedule`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getNumberOfIssuesPerYear = createAsyncThunk(
  "Statistics/getNumberOfIssuesPerYear",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/index/number_of_issues_per_year`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getNumberOfIssuesPerCourt = createAsyncThunk(
  "Statistics/getNumberOfIssuesPerCourt",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/index/number_of_issues_per_court`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getNumberOfIssuesPerUser = createAsyncThunk(
  "Statistics/getNumberOfIssuesPerUser",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/index/number_of_issues_per_user`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getProcedUresAndAchievements = createAsyncThunk(
  "Statistics/getProcedUresAndAchievements",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/index/procedures_and_achievements`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
const StatisticsSlice = createSlice({
  name: "Statistics",
  initialState: {
    isStatisticsLoading: false,
    error: null,
    UserStatisticsArray: null,
    EmployeeStatisticsArray: null,
    VerdictsStatisticsArray: null,
    IssuesReportArray: null,
    VerdictsReportArray: null,
    getformulaArray: null,
    UsersReportArray: null,
    EmployeesReportArray: null,
    ImplementationsReportArray: null,
    TasksReportArray: null,
    SessionsCourtsReportArray: null,
    SessionsUsersReportArray: null,
    EmployeeTrashesArray: null,
    UsersTrashesArray: null,
    IssueTrashesArray: null,
    SummaryOfTheSessionsArray: null,
    FollowScheduleArray: null,
    NumberOfIssuesPerYearArray: null,
    NumberOfIssuesPerCourtArray: null,
    NumberOfIssuesPerUserArray: null,
    ProcedUresAndAchievementsArray: null,
  },

  extraReducers: {
    [getformula.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getformula.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.getformulaArray = action.payload.data;
    },
    [getformula.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    [Addformula.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [Addformula.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    [Addformula.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    [updateformula.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [updateformula.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    [updateformula.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    [Deleteformula.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [Deleteformula.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.getformulaArray = state.getformulaArray.filter(
        (ele) => ele.id !== action.meta.arg
      );
    },
    [Deleteformula.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    [getUserStatistics.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getUserStatistics.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.UserStatisticsArray = action.payload.data;
    },
    [getUserStatistics.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    // getEmployeesStatistics
    [getEmployeesStatistics.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getEmployeesStatistics.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.EmployeeStatisticsArray = action.payload.data;
    },
    [getEmployeesStatistics.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    // getVerdictsStatistics
    [getVerdictsStatistics.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getVerdictsStatistics.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.VerdictsStatisticsArray = action.payload.data;
    },
    [getVerdictsStatistics.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    // getIssuesReport
    [getIssuesReport.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getIssuesReport.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.IssuesReportArray = action.payload.data;
    },
    [getIssuesReport.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },

    // getUsersReport
    [getUsersReport.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getUsersReport.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.UsersReportArray = action.payload.data;
    },
    [getUsersReport.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    // getEmployeesReport
    [getEmployeesReport.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getEmployeesReport.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.EmployeesReportArray = action.payload.data;
    },
    [getEmployeesReport.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    // getVerdictsReport
    [getVerdictsReport.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getVerdictsReport.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.VerdictsReportArray = action.payload.data;
    },
    [getVerdictsReport.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    // getImplementationsReport
    [getImplementationsReport.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getImplementationsReport.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.ImplementationsReportArray = action.payload.data;
    },
    [getImplementationsReport.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    // getTasksReport
    [getTasksReport.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getTasksReport.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.TasksReportArray = action.payload.data;
    },
    [getTasksReport.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    // getSessionsCourtsReport
    [getSessionsCourtsReport.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getSessionsCourtsReport.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.SessionsCourtsReportArray = action.payload.data;
    },
    [getSessionsCourtsReport.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    // getSessionsUsersReport
    [getSessionsUsersReport.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getSessionsUsersReport.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.SessionsUsersReportArray = action.payload.data;
    },
    [getSessionsUsersReport.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    // getSessionsConsultantsReport
    [getSessionsConsultantsReport.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getSessionsConsultantsReport.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.SessionsConsultantsReportArray = action.payload.data;
    },
    [getSessionsConsultantsReport.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    // getDocumentsReport
    [getDocumentsReport.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getDocumentsReport.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.DocumentsReportArray = action.payload.data;
    },
    [getDocumentsReport.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    // getCourtsReport
    [getCourtsReport.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getCourtsReport.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.CourtsReportArray = action.payload.data;
    },
    [getCourtsReport.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    // getEmployeeTrashes
    [getEmployeeTrashes.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getEmployeeTrashes.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.EmployeeTrashesArray = action.payload.data;
    },
    [getEmployeeTrashes.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    // getUsersTrashes
    [getUsersTrashes.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getUsersTrashes.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.UsersTrashesArray = action.payload.data;
    },
    [getUsersTrashes.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    // getIssueTrashes
    [getIssueTrashes.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getIssueTrashes.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.IssueTrashesArray = action.payload.data;
    },
    [getIssueTrashes.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    // ResotreTrashes
    [ResotreTrashes.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [ResotreTrashes.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    [ResotreTrashes.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },

    // ================ Home Reports ================
    [getSummaryOfTheSessions.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getSummaryOfTheSessions.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.SummaryOfTheSessionsArray = action.payload.data;
    },
    [getSummaryOfTheSessions.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    [getFollowSchedule.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getFollowSchedule.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.FollowScheduleArray = action.payload.data;
    },
    [getFollowSchedule.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    [getNumberOfIssuesPerYear.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getNumberOfIssuesPerYear.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.NumberOfIssuesPerYearArray = action.payload.data;
    },
    [getNumberOfIssuesPerYear.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    [getNumberOfIssuesPerCourt.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getNumberOfIssuesPerCourt.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.NumberOfIssuesPerCourtArray = action.payload.data;
    },
    [getNumberOfIssuesPerCourt.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    [getNumberOfIssuesPerUser.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getNumberOfIssuesPerUser.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.NumberOfIssuesPerUserArray = action.payload.data;
    },
    [getNumberOfIssuesPerUser.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
    [getProcedUresAndAchievements.pending]: (state, action) => {
      state.isStatisticsLoading = true;
    },
    [getProcedUresAndAchievements.fulfilled]: (state, action) => {
      state.isStatisticsLoading = false;
      state.ProcedUresAndAchievementsArray = action.payload.data;
    },
    [getProcedUresAndAchievements.rejected]: (state, action) => {
      state.isStatisticsLoading = false;
    },
  },
});

export default StatisticsSlice.reducer;
